import classNames from "classnames";
let buildings = require("../../config/all-buildings.json")

function getDataByPgbid(pgbid) {
    const resultArray = buildings.flatMap(item =>
        item.variations.map(variation => ({
            pbgid: variation.pbgid,
            name: item.name,
            icon: item.icon
        }))
    );

    return resultArray.find(item => item.pbgid === pgbid) || null;
}

export function LiveGameMilitaryBuilding({ pbgid, count, inQueue, isUnique = false, leftSide, showCount = true}) {
    const data = getDataByPgbid(pbgid);

    return (
        <div className={classNames("w-[70px] h-[40px] flex", leftSide ? "flex-row-reverse" : "flex-row")}>
            {showCount &&
            <div className="w-[30px] bg-[#252525dc] flex flex-col">
                <h1 className={classNames("h-5 px-1 text-[#b1b1b1] align-top -mt-[2px] italic", leftSide ? "text-left" : "text-right", inQueue === 0 ? "opacity-0" : "")} style={{textShadow: '2px 2px 3px black'}}>{inQueue}</h1>
                <h1 className={classNames("h-5 px-1 text-white align-top -mt-[2px] ", leftSide ? "text-left" : "text-right")} style={{textShadow: '2px 2px 3px black'}}>{count}</h1>
            </div>
            }
            <div className="w-[40px] relative" style={{backgroundImage: `url(/liveGameIcons/military_background.png)`}}>
                <img className="w-10 h-10" src={data?.icon} alt="" />
                {isUnique && <img className="absolute bottom-0 left-0 w-4 h-4" src={`/liveGameIcons/unique.png`} alt="" />}
            </div>
        </div>
    );
}
